import { render } from "./account_manage.vue?vue&type=template&id=8aaf0aea&scoped=true"
import script from "./account_manage.vue?vue&type=script&lang=js"
export * from "./account_manage.vue?vue&type=script&lang=js"

import "./account_manage.vue?vue&type=style&index=0&id=8aaf0aea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aaf0aea"]])

export default __exports__